// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3ujlI","row":"Node_row__1tRoP","label":"Node_label__3npnY","footer":"Node_footer__3g2we"};